// extracted by mini-css-extract-plugin
module.exports = {"root":"_4KXXQu4RbgTTt9ugE5hU","item":"vKeEZTwBOpJBXgNNh9RK"};